import React from 'react';
import { Alert } from 'reactstrap';

const BinStatus = ({ status, bank, brand, error }) => {
    if (status === 'loading') {
        return <div className="text-info mb-3"><small><i className="bx bx-loader-alt bx-spin me-1" />Kart bilgileri kontrol ediliyor...</small></div>;
    }
    if (status === 'success') {
        return <div className="text-success mb-3"><small><i className="bx bx-check-circle me-1" />Kart tanımlandı: {bank} - {brand}</small></div>;
    }
    if (status === 'paytr_not_found' || status === 'error') {
        return (
            <Alert color="warning" className="mb-3">
                <i className="bx bx-warning me-2" />
                {error}
            </Alert>
        );
    }
    return null;
};

export default BinStatus;